import React from "react";
import { motion } from "framer-motion";

const HomeSectionHeading = ({ id, title, subtitle, className = "mb-8 lg:mb-14" }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, ease: "easeOut" }}
    className={`text-center ${className}`}
  >
    <h2
      id={id}
      className="text-center text-3xl md:text-4xl font-extrabold tracking-tight text-transparent bg-clip-text bg-[var(--bg-primary)] drop-shadow-sm mb-2 lg:mb-2"
    >
      {title}
    </h2>
    <div className="w-40 h-1 bg-[#F86624] mx-auto rounded-full mb-2" />
    <p className="text-sm md:text-sm text-gray-500 text-center max-w-md mx-auto">
      {subtitle}
    </p>
  </motion.div>
);

export default HomeSectionHeading;
